import { render, staticRenderFns } from "./termsOfServiceCN.vue?vue&type=template&id=03334b78&scoped=true"
import script from "./termsOfServiceCN.vue?vue&type=script&lang=js"
export * from "./termsOfServiceCN.vue?vue&type=script&lang=js"
import style0 from "./termsOfServiceCN.vue?vue&type=style&index=0&id=03334b78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03334b78",
  null
  
)

export default component.exports